import { render, staticRenderFns } from "./Naplata.vue?vue&type=template&id=5bbd6f3e"
import script from "./Naplata.vue?vue&type=script&lang=js"
export * from "./Naplata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports